import {
  UPDATE_USER,
  RESET_VALUE,
  UPDATE_ACCESS_KEY,
  UPDATE_PROXY_SETTINGS,
  UPDATE_PROXY_OBJECT,
  UPDATE_VERBOSE,
} from '../actions/updateconfig';

const initialState = {
  name: '',
  email: '',
  accessKey: '',
  urlKey: '',
  username: '',
  userId: '',
  orgId: '',
  byodGuiFlag: false,
  verbose: false,
  proxy: {
    enable: false,
    secure: false,
    username: '',
    password: '',
    hostname: '',
    port: '',
  },
};

export default function userConfig(state = initialState, action: any) {
  switch (action.type) {
    case UPDATE_USER:
      if (action.payload.userId) {
        localStorage.setItem('userId', action.payload.userId);
      }
      return {
        ...state,
        name: action.payload.name,
        urlKey: action.payload.urlKey,
        email: action.payload.email,
        userId: action.payload.userId,
        maxConcurrency: action.payload.maxConcurrency,
        orgId: action.payload.orgId,
        byodGuiFlag: action.payload?.byodGuiFlag,
        ...action.payload,
      };
    case UPDATE_ACCESS_KEY:
      return {
        ...state,
        accessKey: action.payload.accessKey,
        username: action.payload.username,
      };
    case RESET_VALUE:
      return initialState;
    case UPDATE_PROXY_SETTINGS:
      return {
        ...state,
        proxy: {
          ...state.proxy,
          [action.payload.key]: action.payload.value,
        },
      };
    case UPDATE_PROXY_OBJECT:
      return {
        ...state,
        proxy: action.payload,
      };
    case UPDATE_VERBOSE:
      return {
        ...state,
        verbose: action.payload.verbose,
      };
    default:
      return { ...state };
  }
}
